var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPawprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-542 -1787)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pawprint 1",
    clipPath: "url(#clip0_125_1901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6988 8.47974C9.97882 7.35657 8.75262 6.68591 7.41864 6.68591C6.08478 6.68591 4.85846 7.35657 4.13861 8.47974L2.40375 11.1862C2.1159 11.6353 1.98309 12.1539 2.01959 12.686C2.05609 13.2183 2.2586 13.7139 2.60516 14.1195C2.95196 14.525 3.41022 14.8021 3.93036 14.921C4.4505 15.0398 4.9837 14.9891 5.47223 14.7744L5.50409 14.7603C6.73346 14.2303 8.13861 14.2351 9.36493 14.7744C9.68121 14.9135 10.0163 14.9838 10.3544 14.9838C10.5383 14.9838 10.7232 14.9629 10.9064 14.9211C11.4266 14.8024 11.8848 14.5253 12.2317 14.1198C12.5784 13.7142 12.7811 13.2185 12.8177 12.6863C12.8543 12.1539 12.7215 11.6353 12.4337 11.186L10.6988 8.47974ZM11.519 13.5101C11.0777 14.026 10.3638 14.1891 9.74249 13.9159C9.00397 13.5911 8.21124 13.4287 7.41827 13.4287C6.62604 13.4287 5.83343 13.5909 5.0954 13.9154L5.0744 13.9247C4.45782 14.1854 3.75445 14.0203 3.31805 13.5101C2.87726 12.9941 2.82709 12.2637 3.1933 11.6923L4.92828 8.98584C5.47491 8.13306 6.40582 7.6239 7.41864 7.6239C8.43146 7.6239 9.36249 8.13306 9.90924 8.98584L11.644 11.6921C12.0103 12.2638 11.96 12.9944 11.519 13.5101Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.87172 8.47619C3.38783 8.27794 3.77992 7.86205 3.97584 7.30504C4.16212 6.77502 4.14686 6.17663 3.93263 5.61999C3.71827 5.06371 3.32838 4.60961 2.83485 4.34118C2.31617 4.05932 1.74647 4.01342 1.23121 4.21203C0.194593 4.61059 -0.281115 5.89159 0.170911 7.06823C0.531995 8.00475 1.37416 8.59594 2.2256 8.59594C2.44301 8.59594 2.66102 8.55736 2.87172 8.47619ZM1.04616 6.73131C0.779798 6.03795 1.01381 5.30041 1.56813 5.08727C1.66823 5.0487 1.77406 5.02953 1.88209 5.02953C2.04884 5.02953 2.22108 5.07506 2.38685 5.16527C2.68495 5.32726 2.92311 5.60851 3.05739 5.95702C3.19154 6.30578 3.2035 6.67394 3.09096 6.99389C2.98781 7.2871 2.79042 7.50268 2.53529 7.6007L2.5348 7.60094C1.98121 7.81432 1.31337 7.42406 1.04616 6.73131Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.23865 6.35583C7.53455 6.35583 8.58887 5.15466 8.58887 3.67822C8.58887 2.20142 7.53455 1 6.23865 1C4.94287 1 3.88867 2.20142 3.88867 3.67822C3.88867 5.15466 4.94287 6.35583 6.23865 6.35583ZM6.23865 1.93787C7.01733 1.93787 7.651 2.71863 7.651 3.67822C7.651 4.63745 7.01733 5.41797 6.23865 5.41797C5.45996 5.41797 4.82654 4.63745 4.82654 3.67822C4.82654 2.71863 5.45996 1.93787 6.23865 1.93787Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.2965 7.01367H10.2967C10.496 7.07983 10.6994 7.11145 10.9019 7.11145C11.8469 7.11145 12.768 6.42358 13.1194 5.36645C13.3218 4.75793 13.3085 4.1145 13.0819 3.55481C12.8449 2.96899 12.4055 2.5437 11.8448 2.35718C11.284 2.1709 10.6771 2.24853 10.1365 2.57593C9.62002 2.88879 9.22427 3.39612 9.02224 4.00464C8.59561 5.28833 9.16726 6.63818 10.2965 7.01367ZM9.91226 4.30041C10.0442 3.90308 10.2964 3.57568 10.6225 3.37817C10.9241 3.19543 11.2532 3.14892 11.549 3.24719C11.8446 3.34558 12.0802 3.57971 12.2125 3.90662C12.3555 4.25989 12.3616 4.67322 12.2294 5.07056C11.9658 5.86352 11.2315 6.33594 10.5924 6.12366C9.95388 5.91125 9.64871 5.09338 9.91226 4.30041Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.2466 6.7012L15.2462 6.70083C14.3525 6.04068 13.016 6.32681 12.2666 7.33902C11.5179 8.35171 11.635 9.71316 12.5273 10.3738C12.8528 10.6149 13.2373 10.7301 13.6308 10.7301C14.3167 10.7301 15.0304 10.38 15.5073 9.73623C16.256 8.72354 16.139 7.36209 15.2466 6.7012ZM14.7535 9.17825C14.311 9.77554 13.5628 9.97366 13.0854 9.62002C12.6084 9.26687 12.5793 8.49368 13.0206 7.89675C13.3139 7.50051 13.7424 7.28006 14.1373 7.28006C14.337 7.28006 14.5282 7.33645 14.6888 7.45523C15.1655 7.80874 15.1944 8.58169 14.7535 9.17825Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawprint);
export default __webpack_public_path__ + "static/media/pawprint.2c8a7bf0378c06dcadcb96c3617c028b.svg";
export { ForwardRef as ReactComponent };